var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDocIcon = function SvgDocIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Attachments in chat list"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 234",
    d: "M36.4004 11.2002H13.4809C10.3881 11.2002 7.88086 13.7074 7.88086 16.8002V42.0002C7.88086 45.093 10.3881 47.6002 13.4809 47.6002H44.2809C47.3737 47.6002 49.8809 45.093 49.8809 42.0002V25.2002M36.4004 11.2002L43.4004 18.2002L49.8809 25.2002M36.4004 11.2002V19.6002C36.4004 22.693 38.9076 25.2002 42.0004 25.2002H49.8809",
    stroke: "#737B7E",
    strokeWidth: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 236",
    d: "M20.0156 28H31.0153M20.0156 33.6H37.7398M20.0156 39.2H37.7398",
    stroke: "#737B7E",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDocIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "doc-icon.49421a2923e41f0e09cf87e135927ed9.svg";